import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleTagManagerModule, GoogleTagManagerService } from 'angular-google-tag-manager';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { CoreModule } from './core/core.module';
import { ContactDialogComponent } from './notification/dashboard/contact-dialog/contact-dialog.component';
import {
  FHIRServiceInjectionToken,
  provideAuthService,
} from './notification/fhir-service.providers';
import { NotificationModule } from './notification/notification.module';
import { DebuggerPanelComponent } from './public/debugger-panel/debugger-panel.component';
import { GatewayErrorComponent } from './public/gateway-error/gateway-error.component';
import { NotFoundComponent } from './public/not-found/not-found.component';
import { SharedModule } from './shared/shared.module';
import { FHIRService } from './notification/fhir.service';

// Function to initialize GTM with authenticated ID
export function initializeGTM(
  gtmService: GoogleTagManagerService,
  authService: FHIRService,
): () => Promise<void> {
  return async () => {
    try {
      const authenticatedId = await authService.getUserId();
      gtmService.pushTag({ event: 'authenticatedUser', userId: authenticatedId });
    } catch (error) {
      console.error('Error initializing GTM:', error);
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    GatewayErrorComponent,
    NotFoundComponent,
    ContactDialogComponent,
    DebuggerPanelComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgxJsonViewerModule,
    ClipboardModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    AuthModule,
    NotificationModule,
    GoogleTagManagerModule.forRoot({
      id: environment.gtmId,
      gtm_auth: environment.gtmAuth,
      gtm_preview: environment.gtmPreview,
    }),
  ],
  providers: [
    provideAuthService(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGTM,
      deps: [GoogleTagManagerService, FHIRServiceInjectionToken],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
